module.exports = __webpack_public_path__ + "static/media/SiteBuilder-Screenshot-5.6a8ab26b.png";